<template>
  <div class="spellchecker-survey-form" v-if="isVisible">
    <div class="form-header">
      <div class="flex">
        <img src="@/assets/images/ai-generator/circle-check-offset.svg" alt="Advanced Check">
        <p class="font-bold ml-2 text-base">
          What else do you want to check?
        </p>
      </div>
      <aha-icon-button size="sm" v-aha-click="onCloseButtonClicked" name="spellchecker-fake-door-close-button">
        <aha-icon name="close-v2" />
      </aha-icon-button>
    </div>
    <FakeDoorFormStepOne
      v-if="!isStepTwoVisible"
      @onCheckButtonClicked="handleTrackingAndNextStep"
    />
    <FakeDoorFormStepTwo v-if="isStepTwoVisible" @onNotifyButtonClicked="onCloseButtonClicked" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FakeDoorFormStepOne from '@/components-v2/presentation-editor/editor-header/quality-control/FakeDoorFormStepOne.vue'
import FakeDoorFormStepTwo from '@/components-v2/presentation-editor/editor-header/quality-control/FakeDoorFormStepTwo.vue'

import * as localStorageExpiry from '@/utils/local.storage.expiry'
import { spellcheckerFakeDoorTestExpiryDate } from '@/constant/fixedDate'

export default {

  components: {
    FakeDoorFormStepOne,
    FakeDoorFormStepTwo,
  },

  data() {
    return {
      isStepTwoVisible: false,
      isFormClosed: false,
    }
  },

  computed: {
    ...mapState({
      currentUserId: (state) => state.currentUser?.id,
    }),

    isVisible() {
      return !localStorageExpiry.getWithExpiry(this.localStorageKey) && !this.isFormClosed
    },

    localStorageKey() {
      return `has-closed-spellchecker-fake-door-test-${this.currentUserId}`
    },
  },

  methods: {
    onCloseButtonClicked() {
      localStorageExpiry.setWithExpiry(this.localStorageKey, true, spellcheckerFakeDoorTestExpiryDate)
      this.isFormClosed = true
    },

    handleTrackingAndNextStep() {
      this.isStepTwoVisible = true
    },
  },
}
</script>

<style lang="scss" scoped>
.spellchecker-survey-form {
  @apply my-4 mx-auto;
  @apply bg-primary-40 rounded p-5;
  width: calc(100% - 2rem);
  .form-header {
    @apply flex items-center justify-between;
  }
}
</style>
